<div class="order-form-nudge border-radius-8" [ngStyle]="{'borderLeft': '16px solid ' + statusColor}">
  <div class="notification-content">
    <div class="notification-header">
      <span class="font-14 font-600" [style.color]="statusColor">
        <ng-container *ngIf="data?.is_gtt || data?.is_super; else normalOrder">
       {{data?.is_gtt ? 'GTT Order' : 'Super Order'}} {{ displayStatus }}
        </ng-container>
        <ng-template #normalOrder>
          Order {{ displayStatus }}
        </ng-template>
      </span>
      <button mat-icon-button (click)="close()" class="close-btn cursor-pointer no-background dialog-close-btn">
        <span class="material-icons">clear</span>
      </button>
    </div>
    <div class="notification-body font-12 font-500">
      <p class="order-text">{{ orderText }}</p>
      <p *ngIf="statusText" class="sub-text">{{ statusText }}</p>
      <a *ngIf="showAddFundsButton" class="add-funds-link decoration-underline 
      cursor-pointer margin-8-bottom" (click)="navigateToFunds()">Add Funds</a>
      <a *ngIf="showAuthorizeButton" class="add-funds-link decoration-underline 
      cursor-pointer margin-8-bottom" (click)="navigateToAuthorize()">Please click here to Authorize</a>
    </div>
  </div>
</div>